module.exports = __webpack_public_path__ + "assets/img/dll.19bb0866.svg";